import {OptionenSlider} from "./optionen-slider.js";

class VariantenAuswahl extends HTMLElement {
  constructor() {
    super();
    this.sliderContainer = this.querySelectorAll(".optionen");
  }

  connectedCallback() {
    this.sliderContainer.forEach(function(formatVariante, index) {
      let formatSlider = new OptionenSlider(formatVariante);
      formatSlider.init();
    })
  }
}

if (!customElements.get("varianten-auswahl")) {
  customElements.define("varianten-auswahl", VariantenAuswahl);
}
